import React from "react";

export default function MiniStat({ icon, label, value, color }) {
  return (
    <div className="bg-white p-3 sm:p-4 rounded-2xl border border-slate-200 shadow-sm flex items-center gap-2 sm:gap-3 transition-all hover:shadow-md min-h-[85px] overflow-hidden">
      <div className={`p-2 sm:p-2.5 rounded-xl bg-slate-50 ${color} flex-shrink-0`}>
        {React.isValidElement(icon) ? React.cloneElement(icon, { size: 18 }) : icon}
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[9px] sm:text-[10px] font-black text-slate-400 uppercase tracking-tight sm:tracking-widest leading-tight mb-1 truncate">
          {label}
        </p>
        <p className="text-sm sm:text-base font-black text-slate-900 truncate">
          {value}
        </p>
      </div>
    </div>
  );
}